import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { EmployeeAddress } from '@pxtra-client-lib-legacy/gen';
import { DataGrid } from '../../../../lib/components/compound/dataGrid';
import { EmployeeDataGridElement } from '../shared/dataGridElement';
import { Loading } from '../../../../lib/components';
import { countryLabel } from '../../../../misc/countries';

interface Props {
  data: EmployeeAddress | undefined;
}

export const AddressDataView: FC<Props> = ({ data }) => {
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage;

  return data ? (
    <DataGrid>
      <EmployeeDataGridElement data={data} field="street_name_and_number" xs={12} />
      <EmployeeDataGridElement data={data} field="address_supplement" xs={12} />
      <EmployeeDataGridElement data={data} field="zip_code" />
      <EmployeeDataGridElement data={data} field="city" />
      <EmployeeDataGridElement data={data} field="province" />
      <EmployeeDataGridElement
        data={data}
        field="country"
        renderValue={(value) => countryLabel(value as string | null | undefined, language)}
      />
    </DataGrid>
  ) : (
    <Loading />
  );
};
